import React, { useRef } from 'react';

const ProjectCarousel = ({ projects, onProjectClick }) => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const { current } = scrollContainerRef;
      const scrollAmount = 400;
      current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleProjectClick = (project) => {
    // All projects are clickable and show overlay
    onProjectClick(project);
  };

  return (
    <div className="project-carousel-container position-relative">
      {/* Left Arrow */}
      <button
        className="carousel-arrow left-arrow"
        onClick={() => scroll('left')}
        aria-label="Scroll left"
      >
        &lt;
      </button>

      {/* Scrollable Track */}
      <div className="carousel-track" ref={scrollContainerRef}>
        {projects.map((project, index) => (
          <div 
            key={index} 
            className="carousel-item-card bento-item clickable-project"
            data-aos="fade-up" 
            data-aos-delay={100 * index}
            onClick={() => handleProjectClick(project)}
          >
            <div className="project-highlight"></div>
            <div className="accent-line"></div>
            <h3>{project.title}</h3>
            <p className="text-accent mb-3" style={{ fontSize: '0.9rem' }}>
              {project.description}
            </p>
            <div className="d-flex flex-wrap gap-2 mt-auto">
              {project.tags.map((tag, i) => (
                <span key={i} className="badge-minimal">
                  {tag}
                </span>
              ))}
            </div>
            <div className="project-hint"></div>
          </div>
        ))}
      </div>

      {/* Right Arrow */}
      <button
        className="carousel-arrow right-arrow"
        onClick={() => scroll('right')}
        aria-label="Scroll right"
      >
        &gt;
      </button>
    </div>
  );
};

export default ProjectCarousel;
